import React, { useRef, useState, useEffect } from 'react';
import { Formik } from 'formik';
import Divider from '~/components/divider';
import {
  Container,
  Header,
  HeaderData,
  Row,
  Employees,
  Employee,
  InputItem,
} from '~/views/checkout/styles';
import { InputLabel, Autocomplete } from '~/components/form';
import logo from '~/assets/logo.png';
import { FaBarcode } from 'react-icons/fa';
import useCheckout from '~/view-data/use-checkout';
import _ from 'lodash';
import { formats } from '~/helper';
import useEventListener from '~/hooks/use-event-listener';
import userImage from '~/assets/user.svg';

function Checkout({ acls }) {
  const [searchCredential, setSearchCredential] = useState('');
  const refCredentialNumber = useRef(null);
  const canWrite = acls.includes('W');
  const { state, actions } = useCheckout();

  useEffect(() => {
    _.defer(() => {
      if (refCredentialNumber && refCredentialNumber.current) {
        refCredentialNumber.current.focus();
      }
    });
  }, [state, state.model]);

  const handleChangeSearchCredentialNumber = (event) => {
    setSearchCredential(event.target.value);
  };

  useEventListener({
    name: 'keydown',
    handler: onKeyDown,
    elementId: 'white-checkout-credential-search',
  });

  async function onKeyDown(event) {
    const charCode = event.which || event.keyCode;

    if (charCode === 27) {
      setSearchCredential('');
    }

    if (charCode === 13) {
      await handleCheckout();
      event.preventDefault();
    }
  }

  const handleCheckout = async () => {
    await actions.checkoutByCredentialNumber(searchCredential);
    setSearchCredential('');
  };

  return (
    <Container>
      <Formik enableReinitialize={true} validateOnMount={true} initialValues={state.model}>
        {({ values }) => (
          <>
            <Header>
              <HeaderData>
                <Autocomplete
                  name="event"
                  minLength={1}
                  keyField="id"
                  label="Evento"
                  value={_.get(values, 'event')}
                  disabled={!canWrite}
                  valueFormat={(row) => `${row.name}`}
                  loadData={actions.eventsFinding}
                  emptyText={'Pesquise o evento'}
                  tipText={'Digite... '}
                  loadingText={'Carregando...'}
                  notFoundText={'Não encontrado'}
                  onChange={(value) => {
                    actions.selectEvent(value);
                  }}
                />
                <Row span={4}>
                  <InputLabel
                    label="Tipo do evento"
                    value={_.get(values, 'event.eventType.name')}
                  />
                  <InputLabel
                    label="Local do evento"
                    value={_.get(values, 'event.place.name')}
                    noMargin
                  />
                  <InputLabel
                    label="Data/Hora início do evento"
                    value={formats.dateTimeZone(
                      _.get(values, 'event.eventDate'),
                      'dd/MM/yyyy HH:mm'
                    )}
                    noMargin
                  />
                  <InputLabel
                    label="Data/Hora término do evento"
                    value={formats.dateTimeZone(
                      _.get(values, 'event.eventEndDate'),
                      'dd/MM/yyyy HH:mm'
                    )}
                    noMargin
                  />
                </Row>
                <Row>
                  <InputItem>
                    <input
                      ref={refCredentialNumber}
                      id="white-checkout-credential-search"
                      name="white-checkout-credential-search"
                      type="text"
                      disabled={!canWrite || !actions.isSelectedEvent()}
                      placeholder="Pesquisa por número da credencial"
                      onChange={handleChangeSearchCredentialNumber}
                      value={searchCredential}
                    />
                    <label htmlFor="white-matchday-credential-search">
                      Pesquisa por número da credencial
                    </label>
                    <FaBarcode onClick={handleCheckout} />
                  </InputItem>
                </Row>
              </HeaderData>
              <img src={logo} alt="Palmeiras" />
            </Header>

            <Divider label="Checkouts" />

            <Employees>
              {_.get(state, 'data').map((row) => (
                  <Employee key={_.get(row, 'id')}>
                    <div className="avatar">
                      <img src={_.get(row, 'person.photo') || userImage} alt="" />
                    </div>
                    <div>
                      <div className="info">
                        <strong>
                          {_.get(row, 'person.name')} ({_.get(row, 'credentialNumber') || '---'})
                        </strong>
                        <div className="checks">
                          <span>{_.get(row, 'checkInDate') || '--/--/----'} - </span>
                          <span>{_.get(row, 'checkOutDate') || '--/--/----'}</span>
                        </div>
                      </div>
                      <div className="subInfo">
                        <span>{_.get(row, 'company.name')}</span>
                        <div>
                          função: {_.get(row, 'role.name')} | área: {_.get(row, 'checkInArea')}
                        </div>
                      </div>
                    </div>
                  </Employee>
                ))
              }
            </Employees>
          </>
        )}
      </Formik>
    </Container>
  );
}

export default Checkout;
